export const reportTiles = {
  PROJECTS: 'Projects',
  CONCRETE_USER: 'Concrete user',
  USERS: 'Users',
  CONTRACT: 'Contract',
  TECHNOLOGY: 'Technology',
} as const

export type ReportTileKey = keyof typeof reportTiles
export type ReportTileValue = (typeof reportTiles)[ReportTileKey]
